/* unplugin-vue-components disabled */import script from "./viewerButton.vue?vue&type=script&setup=true&name=viewerButton&lang=js"
export * from "./viewerButton.vue?vue&type=script&setup=true&name=viewerButton&lang=js"

import "./viewerButton.vue?vue&type=style&index=0&id=54cc0fb1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54cc0fb1"]])

export default __exports__